<template>
	<div class="partner_new">
    <img class="header-img" src="../assets/images/header-newpartner.png"/>
    <div class="logo-area">
      <div v-for="item in logos" class="logo-item" @mouseenter="item.isHover=true" @mouseleave="item.isHover=false">
        <img class="logo-img" :src="item.isHover ? item.hover : item.normal"/>
      </div>
    </div>
    <div class="subtitle">人工智能平台赋能数字化未来</div>
    <div class="information-area">
      <div class="col-item" @mouseenter="imgs[0].isHover=true" @mouseleave="imgs[0].isHover=false">
        <img :src="imgs[0].src"/>
        <div class="content"><span>{{ imgs[0].text }}</span></div>
        <div v-show="imgs[0].isHover" class="mask">
          <img src="../assets/images/logoWhite.png"/>
          <div class="entrance">立即前往</div>
        </div>
      </div>
      <div class="col-item" @mouseenter="imgs[1].isHover=true" @mouseleave="imgs[1].isHover=false">
        <router-link to="/news">
          <img :src="imgs[1].src"/>
          <div class="content"><span>{{ imgs[1].text }}</span></div>
          <div v-show="imgs[1].isHover" class="mask">
            <img src="../assets/images/logoWhite.png"/>
            <div class="entrance">立即前往</div>
          </div>
        </router-link>
      </div>
      <div class="col-item" @mouseenter="imgs[2].isHover=true" @mouseleave="imgs[2].isHover=false">
        <router-link to="/contact-us-new">
          <img :src="imgs[2].src"/>
          <div class="content"><span>{{ imgs[2].text }}</span></div>
          <div v-show="imgs[2].isHover" class="mask">
            <img src="../assets/images/logoWhite.png"/>
            <div class="entrance">立即前往</div>
          </div>
        </router-link>
      </div>
    </div>
    <img class="footer-img" src="../assets/images/footer-newpartner.png"/>
	</div>
</template>

<script>
	export default {
		name: 'Product',
		data() {
			return {
        logos: [
          {
					  normal: require('@/assets/images/partners/partner01-normal.png'),
            hover: require('@/assets/images/partners/partner01-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner02-normal.png'),
            hover: require('@/assets/images/partners/partner02-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner03-normal.png'),
            hover: require('@/assets/images/partners/partner03-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner04-normal.png'),
            hover: require('@/assets/images/partners/partner04-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner05-normal.png'),
            hover: require('@/assets/images/partners/partner05-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner06-normal.png'),
            hover: require('@/assets/images/partners/partner06-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner07-normal.png'),
            hover: require('@/assets/images/partners/partner07-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner08-normal.png'),
            hover: require('@/assets/images/partners/partner08-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner09-normal.png'),
            hover: require('@/assets/images/partners/partner09-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner10-normal.png'),
            hover: require('@/assets/images/partners/partner10-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner11-normal.png'),
            hover: require('@/assets/images/partners/partner11-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner12-normal.png'),
            hover: require('@/assets/images/partners/partner12-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner13-normal.png'),
            hover: require('@/assets/images/partners/partner13-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner14-normal.png'),
            hover: require('@/assets/images/partners/partner14-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner15-normal.png'),
            hover: require('@/assets/images/partners/partner15-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner16-normal.png'),
            hover: require('@/assets/images/partners/partner16-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner17-normal.png'),
            hover: require('@/assets/images/partners/partner17-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner18-normal.png'),
            hover: require('@/assets/images/partners/partner18-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner19-normal.png'),
            hover: require('@/assets/images/partners/partner19-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner20-normal.png'),
            hover: require('@/assets/images/partners/partner20-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner21-normal.png'),
            hover: require('@/assets/images/partners/partner21-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner22-normal.png'),
            hover: require('@/assets/images/partners/partner22-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner23-normal.png'),
            hover: require('@/assets/images/partners/partner23-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner24-normal.png'),
            hover: require('@/assets/images/partners/partner24-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner25-normal.png'),
            hover: require('@/assets/images/partners/partner25-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner26-normal.png'),
            hover: require('@/assets/images/partners/partner26-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner27-normal.png'),
            hover: require('@/assets/images/partners/partner27-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner28-normal.png'),
            hover: require('@/assets/images/partners/partner28-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner29-normal.png'),
            hover: require('@/assets/images/partners/partner29-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner30-normal.png'),
            hover: require('@/assets/images/partners/partner30-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner31-normal.png'),
            hover: require('@/assets/images/partners/partner31-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner32-normal.png'),
            hover: require('@/assets/images/partners/partner32-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner33-normal.png'),
            hover: require('@/assets/images/partners/partner33-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner34-normal.png'),
            hover: require('@/assets/images/partners/partner34-hover.png'),
            isHover: false
          },
          {
            normal: require('@/assets/images/partners/partner35-normal.png'),
            hover: require('@/assets/images/partners/partner35-hover.png'),
            isHover: false
          }
        ],
        imgs: [
          {
            id: 0,
            text: '渠道合作',
            src: require('@/assets/images/cooperationNew.png'),
            url: '/solution/industry',
            isHover:false,
          },
          {
            id: 1,
            text: '最新资讯',
            src: require('@/assets/images/informationNew.png'),
            url: '/solution/finance',
            isHover:false,
          },
          {
            id: 2,
            text: '联系我们',
            src: require('@/assets/images/contactUsNew.png'),
            url: '/solution/education',
            isHover:false,
          }
        ],
			}
		},
  }
</script>

<style>
	@media(min-width:992px) {
    .partner_new {
      width: 100%;
      background: #ffffff;
      /*background-size: 100% 100%;*/
      overflow-y: hidden;
      position: relative;
    }
    .partner_new .subtitle {
      width: 390px;
      height: 34px;
      font-size: 30px;
      font-weight: 500;
      color: #3A3F4D;
      line-height: 34px;
      margin: 240px auto 0;
    }
    .partner_new .header-img {
      width: 100%;
      height: 424px;
      position: absolute;
      top: 0;
      left: 0;
    }
    .partner_new .footer-img {
      width: 100%;
      height: 365px;
      position: absolute;
      bottom: 0;
      left: 0;
    }
    .partner_new .logo-area {
      width: 1421px;
      height: 466px;
      margin: 224px auto 0;
      position: relative;
      z-index: 1;
    }
    .partner_new .logo-item {
      width: 201px;
      height: 92px;
      background: #FFFFFF;
      border: 1px solid #E4E4E4;
      display: flex;
      align-items: center;
      justify-content: center;
      float: left;
    }
    .partner_new .logo-item:hover {
      width: 201px;
      height: 92px;
      background: #F5F6F9;
      border: 1px solid #E4E4E4;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .partner_new .logo-item .logo-img {
    }
    .information-area {
      width: 1330px;
      margin: 71px auto 120px;
      display: flex;
      align-items: center;
      justify-content: start;
      z-index: 1;
      position: relative;
    }
    .information-area .col-item {
      cursor: pointer;
      width: 442px;
      height: 547px;
      background: #FFFFFF;
      box-shadow: 0px 2px 16px 0px rgba(0,0,0,0.13);
      position: relative;
    }
    .information-area .col-item .mask {
      z-index: 999;
      height: 442px;
      width: 442px;
      position: absolute;
      background: #000000;
      opacity: 0.53;
      top: 0;
    }
    .information-area .col-item .mask img {
      margin: 177px auto 0;
      width: 69px;
      height: 40px;
    }
    .information-area .col-item .mask .entrance {
      margin: 26px auto 0;
      width: 80px;
      height: 22px;
      font-size: 20px;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 22px;
    }
    .information-area .col-item .content {
      width: 442px;
      height: 105px;
      background: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .information-area .col-item .content span {
      width: 105px;
      height: 31px;
      font-size: 26px;
      font-weight: 500;
      color: #000000;
      line-height: 31px;
    }
    .information-area .col-item:hover .content {
      width: 442px;
      height: 105px;
      background: #008FFF;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .information-area .col-item:hover .content span {
      width: 105px;
      height: 31px;
      font-size: 26px;
      font-weight: 500;
      color: #ffffff;
      line-height: 31px;
    }
	}

	@media(max-width:992px) {
    .partner_new {
      width: 100%;
      background: #ffffff;
      /*background-size: 100% 100%;*/
      overflow-y: hidden;
      position: relative;
      margin-bottom: 8vw;
    }
    .partner_new .subtitle {
      font-size: 20px;
      font-weight: 500;
      color: #3A3F4D;
      line-height: 24px;
      margin: 30px auto 0;
    }
    .partner_new .header-img {
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
    .partner_new .footer-img {
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
    }
    .partner_new .logo-area {
      width: 74%;
      margin: 50px auto 0;
      position: relative;
      z-index: 1;
      display: grid;
      grid-template-columns: repeat(5, 20%);
    }
    .partner_new .logo-item {
      width: 100%;
      height: 60px;
      background: #FFFFFF;
      border: 1px solid #E4E4E4;
      display: flex;
      align-items: center;
      justify-content: center;
      float: left;
    }
    .partner_new .logo-item .logo-img {
      width: 90%;
    }
    .information-area {
      width: 75vw;
      margin: 30px auto;
      z-index: 1;
      position: relative;
      display: none;
    }
    .information-area .col-item {
      cursor: pointer;
      width: 75vw;
      height: 90vw;
      background: #FFFFFF;
      box-shadow: 0px 2px 16px 0px rgba(0,0,0,0.13);
      position: relative;
      margin-bottom: 10vw;
    }
    .information-area .col-item img {
      width: 100%;
    }
    .information-area .col-item .mask {
      z-index: 999;
      width: 75vw;
      height: 75vw;
      position: absolute;
      background: #000000;
      opacity: 0.53;
      top: 0;
      display: none;
    }
    .information-area .col-item .mask img {
      margin: auto;
      width: 69px;
      height: 40px;
    }
    .information-area .col-item .mask .entrance {
      margin: 12px auto 0;
      font-size: 20px;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 22px;
    }
    .information-area .col-item .content {
      width: 100%;
      height: 15vw;
      background: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;

    }
    .information-area .col-item .content span {
      font-size: 20px;
      font-weight: 500;
      color: #000000;
      line-height: 25px;
    }
	}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/PartnerNew.vue